import { Link } from 'react-router-dom';
import { getArticleById } from '@/mocks/articles';
import { useParams } from 'react-router-dom';

export default function RelatedArticles() {
  const { id } = useParams<{ id: string }>();
  const articleDetail = getArticleById(id);

  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-10 gap-4">
          <div>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900">
              相关吃瓜推荐
            </h2>
          </div>
          <p className="text-sm text-foreground-500 max-w-md leading-relaxed">
            你可能也对这些热门事件感兴趣
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {articleDetail.relatedArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-2xl overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="flex flex-col sm:flex-row">
                <div className="sm:w-48 h-40 sm:h-auto flex-shrink-0 overflow-hidden">
                  <img
                    src={article.imageUrl}
                    alt={article.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="p-5 flex flex-col justify-center">
                  <span className="px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-bold whitespace-nowrap self-start mb-3">
                    {article.category}
                  </span>
                  <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                    {article.title}
                  </h3>
                  <div className="mt-3 flex items-center gap-1 text-sm font-medium text-primary-600 group-hover:text-primary-700 transition-colors">
                    <span>查看详情</span>
                    <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
